<template>
  <div class="VCode-dialog-box" style="" v-show="isShow">
    <div class="vcode-cover" style="display:block"></div>
    <div class="vcode-mod" style="display:block">
      <i class="close-icon" @click="close"></i>
      <ul>
        <li>
          验证码：
          <span style="color:red">{{ errorMsg }}</span>
        </li>
        <li>
          <input
            id="vcodeinputTxt"
            v-on:input="errorMsg = ''"
            v-on:keyup.enter="submit"
            autocomplete="off"
            class="txt_vcode"
            v-model="codeText"
            type="text"
            placeholder="请输入验证码"
            maxlength="5"
          />
          <span class="vcode"
            ><img :src="imageSrc" @click="getCodeImage"
          /></span>
          <a class="link_change" href="javascript:;" @click="getCodeImage"
            >刷新</a
          >
        </li>
        <li style="display: flex;justify-content: center;">
          <button type="button" id="btn-check" @click="submit">提交</button>
        </li>
        <!-- <li>
                    提交后没解决问题？请<a id="vcode-kf" href="javascript:;">联系客服微信</a>
                </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      isShow: true,
      imageSrc: "",
      errorMsg: "",
      codeText: "",
      guidText: ""
    };
  },
  props: ["successcallback"],
  mounted() {
    this.getId();
  },
  methods: {
    ...mapActions("user", ["AGetGuid", "AGetVcodeImage", "AGetCheckCode"]),
    async getId() {
      var self = this;
      var obj = localStorage.getItem("_5118_Nugd");
      if (obj && obj != "") {
        self.guidText = obj;
        //加载图片
        self.getCodeImage();
        return obj;
      }

      var result = await this.AGetGuid();
      if (result.errorCode == 0) {
        self.guidText = result.data;
        localStorage.setItem("_5118_Nugd", result.data);
        //加载图片
        self.getCodeImage();
      } else {
        self.guidText = "";
        return "";
      }
    },
    async getCodeImage() {
      var result = await this.AGetVcodeImage({ key: this.guidText });
      if (result.ErrorCode == 0) {
        this.imageSrc = result.Data;
      }
    },
    async submit() {
      if (this.codeText == "") {
        this.errorMsg = "验证码不能为空";
        return;
      }

      var result = await this.AGetCheckCode({
        key: this.guidText,
        code: this.codeText
      });
      if (result.ErrorCode == 0) {
        this.successcallback &&
          this.successcallback(this.codeText, this.guidText);
        this.close();
      } else {
        this.errorMsg = "验证码错误或失效，请刷新后重新输入";
      }
      if (result.Data.refresh == 1) {
        //自动刷新验证码
        this.getCodeImage();
      }
    },
    close() {
      this.isShow = false;
      this.$emit("isShowHandle", false);
    }
  }
};
</script>
<style lang="less" scoped>
.VCode-dialog-box {
  font-size: 13px;
  position: relative;
  z-index: 99999;
  .vcode-mod .vcode {
    float: left;
    margin-right: 5px;
  }
  .vcode-mod li {
    padding-bottom: 8px;
    overflow: hidden;
  }
  .vcode-mod .link_change {
    float: left;
    line-height: 40px;
  }
  .vcode-mod button {
    width: 122px;
    line-height: 38px;
    text-align: center;
    font-size: 15px;
    color: #fefefe;
    font-weight: 700;
    background: #5d9afc;
    border-radius: 2px;
    display: inline-block;
    text-decoration: none;
    border: 0;
    border-radius: 4px;
  }
  .vcode-mod img {
    width: 120px;
    height: 40px;
    border: 1px solid #dcdcdc;
  }
  .vcode-mod li {
    padding-bottom: 8px;
    overflow: hidden;
  }
  .vcode-mod li {
    padding-bottom: 8px;
    overflow: hidden;
  }
  .vcode-mod li {
    padding-bottom: 8px;
    overflow: hidden;
  }
  .vcode-mod .txt_vcode {
    float: left;
    width: 152px;
    height: 40px;
    margin-right: 5px;
    padding-left: 5px;
    padding: 3px 5px;
    border: 1px solid #e7e7e7;
    border-radius: 2px;
  }
  .vcode-mod {
    width: 350px;
    // height: 173px;
    height: 150px;
    position: fixed;
    z-index: 1000;
    top: 55%;
    left: 50%;
    margin: -75px 0 0 -175px;
    background: #fff;
    padding: 20px;
    display: none;
    border-radius: 4px;
  }
  .vcode-cover {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 999;
    display: none;
  }
  .close-icon {
    background: url(../../assets/image/vcode-close.png) no-repeat 50%;
    display: block;
    width: 25px;
    height: 25px;
    position: absolute;
    right: 3px;
    top: 4px;
  }
}
</style>
